import React from "react";
import { Row, Col, Form, Button, Modal, Dropdown } from "react-bootstrap";
import axios from "axios";
import UrlConstants from "../../../config/UrlConstants";
import {
  getContactsActions,
  deleteContactAction,
  editSetAsDefaultContactAction,
  getUserRolesAction,
  reActivateDeletedContactAction,
  editContactAction,
  getUserRolesActionNew,
} from "../../../actions/UserActions";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import AddContact from "../../Contacts/CreateContact";
import EditContact from "../../Contacts/EditContact";
import noRecord from "../../../assets/img/no-record.png";
import NoContact from "../../../assets/img/no-contact.jpg";
import PhoneNumber from "../../Common/phoneNumber";
import DataTable from "react-data-table-component";
import Logo from "../../../assets/img/logo.png";
import { toastMessage, cryptoTokenDecode } from "../../Common/Common";
import * as code from "../../../config/Constants";
import { TextField, IconButton } from "@material-ui/core";
import {
  CheckCircle,
  CheckCircleOutline,
  Restore,
  Delete,
  Edit,
  Search,
} from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import { DebounceInput } from "react-debounce-input";
import * as message from "../../../config/CommonMessages";
const ClientsFilter = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      value={filterText}
      onChange={onFilter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      variant="standard"
    />
    <Button
      type="button"
      onClick={onClear}
      variant="primary"
      className="btn-blue btn-head ml-2"
    >
      Clear
    </Button>
  </>
);

const columns = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
    width: "150px",
  },
  {
    name: "Email",
    selector: "Email",
    sortable: true,
    width: "320px",
  },
  {
    name: "Select",
    selector: "isDeletedVendor",
    sortable: true,
    width: "35px",
  },
];
const columns1 = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
  },
  {
    name: "Color",
    selector: "color",
    //sortable: true,
    width: "75px",
  },
  {
    name: "Select",
    selector: "isDeletedVendor",
    //sortable: true,
    width: "115px",
  },
];

function Clients({
  getContactsActions,
  getUserRolesAction,
  deleteContactAction,
  reActivateDeletedContactAction,
  getUserRolesActionNew,
  role,
  previousData,
  DataOfChild,
}) {
  // console.log("selectClient comp role ======>", role);
  // console.log("selectClient comp previousData ======>", previousData);
  // console.log("selectClient comp DataOfChild ======>", DataOfChild);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const [clients, setClients] = React.useState([]);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  const [userType, setUserType] = React.useState(cryptoTokenDecode().usertype);
  const [currentRole, setCurrentRole] = React.useState(
    localStorage.getItem("currentRole")
  );
  const [showLoader, setShowLoader] = React.useState(false);
  const [isSelected, setisSelected] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [PageNumber, setPageNumber] = React.useState(0);
  const [SelectedId, setSelectedId] = React.useState("");
  const [selectedRole, setSelectedRole] = React.useState("");

  React.useEffect(() => {
    setShowLoader(true);
    let ownerId =
      localStorage.getItem("usertype") === "VENDOR"
        ? localStorage.getItem("ownerId")
        : localStorage.getItem("ID");
    getUserRolesActionNew("?id=" + ownerId).then((roleList) => {
      // console.log("roleList", roleList);
      let roleObj = roleList.find((o) => o.name === role);
      // console.log("roleObj", roleObj);
      let roleIdVar = "";
      if (roleObj) {
        roleIdVar = roleObj._id;
        setSelectedRole(roleIdVar);
      }
      getAllClients(roleIdVar);
    });

    if (previousData.length > 0) {
      SetSelected();
    }
  }, [PageNumber, resetPaginationToggle]);

  // function getAllClients(){
  //     let rolename = "admin";
  //     if (userType === message.VENDOR && currentRole === message.BUYERAGENT) {
  //         rolename = "ep";
  //         getContactsActions(rolename, ("?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename))
  //         .then(res => {
  //             getUserRolesAction(("?id=" + localStorage.getItem("ownerId")));
  //             setClients(res.data);
  //             setShowLoader(false);
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         });
  //     } else {
  //         getContactsActions(role)
  //         .then(res => {
  //             console.log("res",res)
  //              getUserRolesAction();
  //             setClients(res.data);
  //             setShowLoader(false);
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         });
  //     }

  //     return clients;
  // };

  const handlePageClick = (event) => {
    //  console.log("1", event.selected);
    setPageNumber(event.selected);
  };

  async function getAllClients(roleIdVar) {
    try {
      var accessToken = localStorage.getItem("accessToken");
      const headersSet = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": accessToken,
      };
      let formData = {
        // page: PageNumber,
        // role: role,
        // searching: filterText,
        // WantDeletedalso: false,
        // SearchWithEmailAlso: false,
        page: PageNumber,
        searching: filterText,
        WantDeletedalso: false,
        SearchWithEmailAlso: false,
        //PageSize: PageSize,
        roleFilter: roleIdVar,
        ownerID: localStorage.getItem("ownerId"),
      };

      const response = await axios.post(
        `${UrlConstants.addContact}/fetchContacts`,
        formData,
        {
          headers: headersSet,
        }
      );

      if (response.status == 200) {
        if (role == "Client") {
          let clientdata = response.data.data;
          clientdata.shift();
          setClients(clientdata);
        } else {
          setClients(response.data.data);
        }

        setnumberOfPages(response.data.total);
        setShowLoader(false);
      }
    } catch (err) {
      console.log(err);
    }
  }

  function deleteClient(id) {
    deleteContactAction(id)
      .then((res) => {
        getAllClients(selectedRole);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function showAddClientModal() {
    setShowAddModal(true);
    // console.log("url", UrlConstants.SiteUrl + 'clients')
  }

  function editClient(id) {
    setShowEditModal(true);
    setContactData({
      id: id,
    });
  }

  const DataOFParticularRow = (event) => {
    // console.log("event", event);
    if (SelectedId == "") {
      // setisSelected(!isSelected)
      setSelectedId(event.UserData[0]._id);
      // DataOfChild(event.UserData[0],role)
      DataOfChild(event, role);
    } else if (SelectedId == event.UserData[0]._id) {
      // setisSelected(!isSelected)
      setSelectedId("");
    } else {
      // setisSelected(!!isSelected)
      setSelectedId(event.UserData[0]._id);
      // DataOfChild(event.UserData[0],role)
      DataOfChild(event, role);
    }

    // console.log("event ======>",event)
    // console.log("row ======>",row)
  };
  const SetSelected = () => {
    // console.log("Set selected calling", isSelected);
    setisSelected(!isSelected);
    setSelectedId(previousData);
  };

  function reActivateUser(userId) {
    reActivateDeletedContactAction(userId)
      .then((response) => {
        getAllClients(selectedRole);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  let rows = [];
  for (var i = 0; i < clients.length; i++) {
    let client = clients[i];

    let contactData = {
      id: client._id,
      firstname:
        client.UserData[0].firstname +
        (client.UserData[0].lastname ? " " + client.UserData[0].lastname : ""),
      // role: client.roles,
      Email:
        client.UserData[0].email && client.UserData[0].email.address
          ? client.UserData[0].email.address
          : "",
      isDeletedVendor:
        SelectedId == client._id ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() => DataOFParticularRow(client)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() => DataOFParticularRow(client)}
          />
        ),
      color: (
        <div
          className={"contact-color-btn"}
          style={{
            height: "20px",
            width: "20px",
            backgroundColor: client.color,
          }}
        />
      ),
    };
    // if(client.isDeletedVendor === false)
    // {
    //     rows.push(contactData)
    // }

    rows.push(contactData);
  }
  // const filteredClients = rows.filter(contact =>
  //     (contact.role === role) &&
  //     (contact.firstname && contact.firstname.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (contact.lastname && contact.lastname.toLowerCase().includes(filterText.toLowerCase()))
  // );

  // const subHeaderComponentMemo = React.useMemo(() => {
  //     const handleClear = () => {
  //         if (filterText) {
  //             setResetPaginationToggle(!resetPaginationToggle);
  //             setFilterText("");
  //         }
  //     };

  //     return (
  //         <ClientsFilter
  //             onFilter={e => setFilterText(e.target.value)}
  //             onClear={handleClear}
  //             filterText={filterText}
  //         />
  //     );
  // });

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const Dosearch = (SearchValue) => {
    // console.log("searchValue",SearchValue)
    setFilterText(SearchValue);
    setResetPaginationToggle(!resetPaginationToggle);
  };
  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const Dosearch = (SearchValue) => {
      // console.log("searchValue",SearchValue)
      setFilterText(SearchValue);
      setResetPaginationToggle(!resetPaginationToggle);
    };

    return (
      // <ClientsFilter
      //     onFilter={(e) => Dosearch(e.target.value)}
      //     onClear={handleClear}
      //     filterText={filterText}
      // />
      <>
        <DebounceInput
          id="search"
          minLength={0}
          debounceTimeout={1000}
          onChange={(e) => Dosearch(e.target.value)}
          placeholder="Search"
          value={filterText}
          autoComplete="off"
        />

        <Button
          type="button"
          onClick={handleClear}
          variant="primary"
          className="btn-blue btn-head ml-2"
        >
          Clear
        </Button>
      </>
    );
  });

  return (
    <div>
      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : rows.length === 0 ? (
        <>
          <div
            className="d-flex justify-content-end mt-2"
            style={{ columnGap: "10px" }}
          >
            <Search style={{ marginTop: "7px" }} />
            <DebounceInput
              id="search"
              minLength={0}
              debounceTimeout={1000}
              onChange={(e) => Dosearch(e.target.value)}
              placeholder="Search"
              value={filterText}
              autoComplete="off"
            />

            <Button
              type="button"
              onClick={handleClear}
              variant="primary"
              className="btn-blue btn-head ml-2"
              style={{ marginRight: "20px" }}
            >
              Clear
            </Button>
          </div>
          <div className="no-transaction">
            <div className="no-transaction-inner">
              <img src={Logo} className="no-transaction-content" alt="" />
              <h2 className="no-transaction-content">No {role} found</h2>
              {/* <Button className="text-uppercase btn-orange btn-orange-lg" onClick={() => {
                            if (localStorage.getItem("isActive") === "false") {
                                toastMessage(code.ERROR, "Your subscription is not active, Please activate to continue.");
                            } else {
                                showAddClientModal()
                            }
                        }}>Add Client</Button> */}
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="d-flex justify-content-end mt-2"
            style={{ columnGap: "10px" }}
          >
            <Search style={{ marginTop: "7px" }} />
            <DebounceInput
              id="search"
              minLength={0}
              debounceTimeout={1000}
              onChange={(e) => Dosearch(e.target.value)}
              placeholder="Search"
              value={filterText}
              autoComplete="off"
            />

            <Button
              type="button"
              onClick={handleClear}
              variant="primary"
              className="btn-blue btn-head ml-2"
              style={{ marginRight: "20px" }}
            >
              Clear
            </Button>
          </div>
          <DataTable
            title="Contacts"
            columns={role == "Artist" ? columns1 : columns}
            data={rows}
            persistTableHead
            dense
          />
        </>
      )}
      {rows.length > 0 && (
        <>
          <div style={{ marginTop: 10 }}>
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={numberOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    getContactsActions,
    deleteContactAction,
    editSetAsDefaultContactAction,
    getUserRolesAction,
    reActivateDeletedContactAction,
    editContactAction,
    getUserRolesActionNew,
  }
)(Clients);
